import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';

interface Props {
  value: string | number | undefined;
  onValueChange: (value: string) => void;
  tooltip?: string;
}

function NumberEditor({ value, onValueChange, tooltip }: Props) {
  const hasValue = value !== undefined && value !== null && value !== '';

  const field = (
    <TextField
      value={hasValue ? value : ''}
      type="number"
      onChange={(event) => onValueChange(event.target.value)}
      error={!hasValue}
      helperText={hasValue ? '' : 'Enter unique range'}
    />
  );

  return (
    <Box>
      {tooltip ? (
        <Tooltip title={tooltip}>
          <span>{field}</span>
        </Tooltip>
      ) : (
        field
      )}
    </Box>
  );
}

export default NumberEditor;
